import React, { Component, useEffect, useState, useContext } from "react";
import Funnel from "./components/TotalFunnel";
import AdminTable from "./components/AdminTable";
import {
  Grid,
} from "@mui/material";
import NumberCard from "../NumberCard";
import DataContext from "../../context/DataContext";

export default function AdminArea() {
  let { adminData } = useContext(DataContext);
  return (
    <Grid container spacing={3}>
      <Grid item xl={6} lg={6} sm={6} xs={12}>
        {/* <TotalClients /> */}
        <NumberCard title={"Total Clients"} data={adminData.adminTotalClients} />
      </Grid>
      <Grid item xl={6} lg={6} sm={6} xs={12}>
        {/* <TotalPositions /> */}
        <NumberCard title={"Total Positions"}  data={adminData.adminTotalPositions} />
      </Grid>

      <Grid item xl={7} lg={7} md={7} sm={8} xs={12}>
        <AdminTable />
      </Grid>

      <Grid item xl={5} lg={5} md={5} sm={4} xs={12}>
        <Funnel />
      </Grid>
    </Grid>
  );
}
